import { useState, useEffect, useCallback } from 'react';
import ScanPage from './pages/ScanPage';
import LandingPage from './pages/LandingPage';
import FeedbackPage from './pages/FeedbackPage';
import IncidentPage from './pages/IncidentPage';
import SuccessPage from './pages/SuccessPage';
import NoPartnerPage from './pages/NoPartnerPage';
import './index.css';

export default function App() {
  const [route, setRoute] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    return p.get('partner_id') && p.get('token') ? 'scan' : 'landing';
  });
  const [partner, setPartner] = useState(null);
  const [partnerLoaded, setPartnerLoaded] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem('scanned_partner');
      setPartner(raw ? JSON.parse(raw) : null);
    } catch {
      setPartner(null);
    } finally {
      setPartnerLoaded(true);
    }
  }, []);

  const onPartnerLoaded = useCallback((p) => {
    setPartner(p);
    setTimeout(() => setRoute('landing'), 1000);
  }, []);

  const onSuccess = useCallback((r) => {
    setResult(r);
    setRoute('success');
  }, []);

  if (route === 'scan') return <ScanPage onPartnerLoaded={onPartnerLoaded} />;
  if (!partnerLoaded) return null;
  if (!partner) return <NoPartnerPage />;
  if (route === 'feedback') return <FeedbackPage partner={partner} onBack={() => setRoute('landing')} onSuccess={onSuccess} />;
  if (route === 'incident') return <IncidentPage partner={partner} onBack={() => setRoute('landing')} onSuccess={onSuccess} />;
  if (route === 'success') return <SuccessPage result={result} onDone={() => setRoute('landing')} />;
  return <LandingPage partner={partner} onFeedback={() => setRoute('feedback')} onIncident={() => setRoute('incident')} />;
}
